/**
 * Guided-tour step catalog.
 *
 * Every step names ONE element by its data-testid. If the element doesn't
 * exist for the current user (RBAC, feature flag), the step is skipped
 * gracefully. Steps are grouped by screen and appear in reading order.
 *
 * `roles` — optional whitelist of roles this step applies to. Omit for "all".
 * `gesture` — optional visual demo name (see GestureDemo.jsx).
 */
export const STEPS = [
  {
    id: 'home-greeting',
    route: '/home',
    targetTestId: 'home-greeting',
    title: 'Home',
    body: 'This is your dashboard — everything that matters today, at a glance.',
  },
  {
    id: 'sidebar-nav',
    route: '/home',
    targetTestId: 'sidebar-nav-my-week',
    title: 'Navigation',
    body: 'Jump between screens from the sidebar. My Week shows what you owe this week.',
  },
  {
    id: 'commitments-drag',
    route: '/commitments',
    targetTestId: 'commitments-tab-me',
    title: 'Commitments',
    body: 'Drag any commitment card between the four columns to reschedule it in one motion.',
    gesture: 'commitment-drag',
  },
  {
    id: 'team',
    route: '/team',
    targetTestId: 'sidebar-nav-team',
    title: 'Team',
    body: 'Who\u2019s here, and who owns what. Select rows to run bulk actions.',
  },
  {
    id: 'projects',
    route: '/master-projects',
    targetTestId: 'sidebar-nav-master-projects',
    title: 'Master Projects',
    body: 'Every live and upcoming project — leads, milestones, and team members in one table.',
  },
  {
    id: 'milestone-slide',
    route: '/master-projects',
    targetTestId: 'sidebar-nav-master-projects',
    title: 'Milestones',
    body: 'Slide the thumb across a milestone to mark it done — no menus, no clicks.',
    gesture: 'milestone-slide',
  },
  {
    id: 'knowledge',
    route: '/knowledge',
    targetTestId: 'sidebar-nav-knowledge',
    title: 'Knowledge Hub',
    body: 'SOPs, email templates, and design resources approved by the studio.',
  },
  {
    id: 'approvals',
    route: '/approvals',
    targetTestId: 'sidebar-nav-approvals',
    title: 'Approvals',
    body: 'One-tap approve or reject bulk changes from Accounts and Design Ops.',
    roles: ['owner'],
  },
  {
    id: 'outbox',
    route: '/outbox',
    targetTestId: 'sidebar-nav-outbox',
    title: 'Email Outbox',
    body: 'Every notification the app sent — receipts of every approval and alert.',
    roles: ['owner', 'operations'],
  },
];
